import {
  TRUTH_DARE_CATEGORIES,
  normalizeTruthDareCategory,
} from "../../../functions/truthDareCategories";
import { downloadCsv, locateCsvColumns, parseCsvRecords } from "./csvTools";

export const QUESTION_MAX = 350;
export const PAGE_SIZES = [10, 25, 50, 100];
const CSV_HEADERS = ["question_name", "category"];

/** Same rows as old/admin/questions-samples.csv. */
const SAMPLE_CSV_ROWS = [
  ["From where does Veeru propose to Basanti in Sholay?", "Truth"],
  ["demo lorem demo lorem", "Dare"],
  ["demo lorem demo lorem demo lorem demo lorem demo lorem demo lorem", "Truth"],
];

export function downloadSampleQuestionsCsv() {
  downloadCsv(CSV_HEADERS, SAMPLE_CSV_ROWS, "questions-samples.csv");
}

/** old/admin/getcsv-admin.php: SELECT question_name, category ... as CSV. */
export function exportQuestionsCsv(questions) {
  downloadCsv(
    CSV_HEADERS,
    questions.map((q) => [q.question_name, q.category]),
    "questions.csv"
  );
}

/**
 * Parse an uploaded CSV into [{ question_name, category }].
 * Throws an Error with a user-facing message on any bad row.
 */
export function parseQuestionsCsv(text) {
  const { index, rows } = locateCsvColumns(parseCsvRecords(text), CSV_HEADERS);
  return rows.map((cells, i) => {
    const rowLabel = `Row ${i + 2}`;
    const question_name = String(cells[index.question_name] ?? "").trim();
    if (!question_name) throw new Error(`${rowLabel}: question_name cannot be empty.`);
    if (question_name.length > QUESTION_MAX) {
      throw new Error(`${rowLabel}: question_name exceeds ${QUESTION_MAX} characters.`);
    }
    const category = normalizeTruthDareCategory(cells[index.category]);
    if (!category) {
      throw new Error(
        `${rowLabel}: category must be one of ${TRUTH_DARE_CATEGORIES.join(", ")}.`
      );
    }
    return { question_name, category };
  });
}
